var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21.999,
    viewBox: "0 0 22 21.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39714",
    d: "M11.1.067h.8a.9.9 0 0 1 .927.915.926.926 0 0 1-.95.868 22.614 22.614 0 0 0-2.277.112 9.145 9.145 0 1 0 10.392 10.582 9.392 9.392 0 0 0 0-3.071c-.117-.7.254-1.218.871-1.23A.927.927 0 0 1 21.8 9 10.995 10.995 0 1 1 9.084.241C9.748.125 10.426.09 11.1.017l.005.05",
    transform: "translate(0 -.016)",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39715",
    d: "M98.767 70.93a12.163 12.163 0 0 1-1.433-.617 2.583 2.583 0 0 1-1.293-1.894.945.945 0 0 1 .768-1.167.924.924 0 0 1 1.04.891.79.79 0 0 0 .492.655 3.136 3.136 0 0 0 2.682 0c.617-.29.623-.823.056-1.206a2.293 2.293 0 0 0-1.309-.34 5.372 5.372 0 0 1-1.826-.285 3 3 0 0 1-1.4-1 2.4 2.4 0 0 1 .94-3.694 12.529 12.529 0 0 1 1.277-.469v-.876a.918.918 0 1 1 1.831 0v.9a10.877 10.877 0 0 1 1.039.339 2.686 2.686 0 0 1 1.689 2.078.938.938 0 0 1-.377 1.009.913.913 0 0 1-1.429-.671.8.8 0 0 0-.514-.73 3.306 3.306 0 0 0-2.638-.007.725.725 0 0 0-.508.667.687.687 0 0 0 .517.656 5.877 5.877 0 0 0 1.307.243 5.57 5.57 0 0 1 1.9.356 2.766 2.766 0 0 1 1.692 1.887 2.454 2.454 0 0 1-1.386 2.764 6.044 6.044 0 0 1-1.075.371c-.156.044-.227.088-.218.259a9.01 9.01 0 0 1 0 .771.914.914 0 1 1-1.828 0c-.007-.314 0-.628 0-.88",
    transform: "translate(-88.684 -55.351)",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39716",
    d: "M194.961 1.831h-1.275a.929.929 0 0 1-1.02-.917A.926.926 0 0 1 193.69 0h3.431a.939.939 0 0 1 1.039 1.046v3.4a.924.924 0 1 1-1.831-.014v-1.3a8.13 8.13 0 0 0-.25.235c-.916.916-1.829 1.836-2.748 2.749a.9.9 0 0 1-1.076.187.85.85 0 0 1-.491-.914 1.3 1.3 0 0 1 .326-.61c.884-.907 1.788-1.8 2.687-2.688a2.758 2.758 0 0 1 .223-.177l-.036-.083",
    transform: "translate(-177.088 -.001)",
    style: {
      fill: "#254089"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.c86bc7c5a6a930752ab9166a6172e3a1.svg";
export { ForwardRef as ReactComponent };